module.exports = "/images/logo-form-simplicity-icon.png?4e2779a3fc2d72cfc6d3ba84495e9697";